// extracted by mini-css-extract-plugin
export default {"container":"footer-module_container_MQq44i","text":"footer-module_text_JEpt41","link-text":"footer-module_link-text_PTUG0c","linkText":"footer-module_link-text_PTUG0c"};